const classifyCatalog = (catalog) => {
    if (catalog?.content?.type === 'Ready') {
        const items = Array.isArray(catalog.content.content) ? catalog.content.content : [];
        return { status: items.length > 0 ? 'results' : 'empty', items };
    }

    if (catalog?.content?.type === 'Err') {
        return catalog.content.content === 'EmptyContent'
            ? { status: 'empty', items: [] }
            : { status: 'error', items: [] };
    }

    return { status: 'pending', items: [] };
};

const summarizeCatalogs = (catalogs) => {
    const states = catalogs.map(classifyCatalog);
    const hasResults = states.some(({ status }) => status === 'results');
    const hasPending = states.some(({ status }) => status === 'pending');
    const hasError = states.some(({ status }) => status === 'error');

    return {
        hasResults,
        hasPending,
        hasError,
        isEmpty: states.length > 0 && !hasResults && !hasPending && !hasError,
    };
};

module.exports = { classifyCatalog, summarizeCatalogs };
